// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__1Xo4X"};